<template>
  <div>
      <div class="craft">
          <div class="part-one">
              <div class="base-title">
                  <!-- <div class="part-one-content"></div> -->
              </div>
          </div>
        <div style="position: relative; top: -3.7rem">
          
          <div class="part-three-extra">
              <img
                  src="../assets/imgs/124/part-1-title.png"
                  class="part-two-title-img"
              />
              <div class="circle-title" style="margin-top: 0.2rem; margin-bottom: 0.2rem">
                <div class="circle"></div>
                （一）领军人才
              </div>
              <div class="main-content" style="margin-top: 0rem">
                  <div class="part-four-items">
                    国家级教学名师、国务院特殊津贴专家， 以及相当于上述层次的人才。
                  </div>
              </div>
              <div class="circle-title" style="margin-top: 0.2rem; margin-bottom: 0.2rem">
                <div class="circle"></div>
                （二）拔尖人才
              </div>
              <div class="main-content" style="margin-top: 0rem">
                  <div class="part-four-items">
                    全国优秀校（园）长、全国优秀教师、全国优秀教育工作者、全国模范教师、省特级教师（校长）、省教书育人名师、省中小学名校长、省中小学名班主任，副省级城市教育专家、市特级校长、市特级教师、正高级教师（作为主要成员〈前 2 名〉承担过副省级以上研究课题并结题或成果获副省级以上奖励）， 以及相当于上述层次的人才。
                  </div>
              </div>
              <div class="circle-title" style="margin-top: 0.2rem; margin-bottom: 0.2rem">
                <div class="circle"></div>
                （三）高级人才
              </div>
              <div class="main-content" style="margin-top: 0rem">
                  <div class="part-four-items">
                    副省级城市学科带头人、博士研究生学历并取得相应学位或经国家认证的硕士及以上学位的留学回国人员、全日制硕士研究生学历并取得相应学位， 以及相当于上述层次的人才。
                  </div>
              </div>
              <div class="circle-title" style="margin-top: 0.2rem; margin-bottom: 0.2rem">
                <div class="circle"></div>
                （四）优秀人才
              </div>
              <div class="main-content" style="margin-top: 0rem">
                  <div class="part-four-items">
                    市优秀青年教师、市教坛新秀、部属师范院校公费师范生，以及相当于上述层次的人才。
                  </div>
              </div>
          </div>
          <div class="part-three-extra" style="background-color: #D4E0FF;">
              <img
                  src="../assets/imgs/124/part-2-title.png"
                  class="part-two-title-img"
              />
              <div class="main-content"  style="margin-top: 0.2rem">
                  <div class="part-four-items">
                    (一)坚持政治素质过硬、职业道德高尚、业务能力精湛、育人水平高超、教育实绩突出。
                  </div>
              </div>
              <div class="main-content" style="margin-top: 0.2rem" >
                  <div class="part-four-items">
                    (二) 引进领军人才、拔尖人才的年龄在 55 周岁及以下，引进高级人才、优秀人才的年龄在 45 周岁及以下。
                  </div>
              </div>
          </div>
          <div class="part-three-extra" style="background-color: #E8EEFF;">
              <img
                  src="../assets/imgs/124/part-3-title.png"
                  class="part-two-title-img"
              />
              <div class="circle-title" style="margin-top: 0.2rem; margin-bottom: 0.2rem">
                <div class="circle"></div>
                （一）津英教育人才引进培育专项奖励
              </div>
              <div class="main-content"  style="margin-top: 0.2rem">
                  <div class="part-four-items">
                    1.对新引进培育的国家级教学名师、国务院特殊津贴专家，奖励个人 100 万元。<br>
                    2.对新引进培育全国优秀校（园）长、全国优秀教师、全国优秀教育工作者、全国模范教师、省特级教师（校长）、教书育人名师、省中小学名校长、省中小学名班主任，副省级 城市教育专家、市特级校长、市特级教师、正高级教师（作为 主要成员〈前 2 名〉承担过副省级以上研究课题并结题或成果获副省级以上奖励），奖励个人 50 万元。<br>
                    3.对新引进培育的副省级城市学科带头人奖励个人 20万元。<br>
                    4.对新引进的博士研究生或经国家认证的硕士及以上学 位的留学回国人员、全日制硕士研究生，分别奖励个人 20 万元、10 万元。<br>
                    5.对新进的部属师范院校公费师范生，奖励个人 5 万元。<br>
                    6.引进培育的津英教育人才同时具备上述多个条件的，按就 高原则享受专项奖励经费，分 5 年平均发放。对新提升为其他 人才类别的，按新的人才类别专项奖励标准在已享受的专项奖励基础上补差。
                  </div>
              </div>
              <div class="circle-title" style="margin-top: 0.2rem; margin-bottom: 0.2rem">
                <div class="circle"></div>
                （二）津英教育人才年度考核奖励
              </div>
              <div class="main-content" style="margin-top: 0.2rem" >
                  <div class="part-four-items">
                    同一层次人才 的考核期最高不超过 5 年（含 5 年），每年由人才自主申报，经 教育主管部门组织考核合格后发放年度考核奖励。 同时具备多个条件的，按就高原则享受。<br>
                    1.国家级教学名师、国务院特殊津贴专家 10 万元/年。<br>
                    2.全国优秀校（园）长、全国优秀教师、全国优秀教育工作者、全国模范教师、省特级教师（校长）、省教书育人名师、省中小学名校长、省中小学名班主任，副省级城市教育专家、 市特级校长、市特级教师、正高级教师（作为主要成员(前 2 名)承担过副省级以上研究课题并结题或成果获副省级以上奖励）5 万元/年。<br>
                    3.副省级城市学科带头人 2 万元/年。<br>
                    4.市优秀青年教师 1.08 万元/年。
                  </div>
              </div>
              <div class="circle-title" style="margin-top: 0.2rem; margin-bottom: 0.2rem">
                <div class="circle"></div>
                （三）组建新津名校（园）教育联盟
              </div>
              <div class="main-content" style="margin-top: 0.2rem" >
                  <div class="part-four-items">
                    培育名校（园）长，每个联盟设首席校（园）长 1 名，负责联盟具体工作。设立名校（园）联盟工作经费，每个联盟每年 100 万元。设立首席校（园）长考核奖励，经考核合格每人每年 20 万元。
                  </div>
              </div>
              <div class="circle-title" style="margin-top: 0.2rem; margin-bottom: 0.2rem">
                <div class="circle"></div>
                （四）成立名师（校长、班主任）工作室
              </div>
              <div class="main-content" style="margin-top: 0.2rem" >
                  <div class="part-four-items">
                    由名师（校长、班主任）担任工作室领衔人，培养骨干教师和名优教师。设立名师（校长、班主任）工作室工作经费，每个工作室按省级、市级，每年分别给予 20 万元、10 万元。
                  </div>
              </div>
          </div>
          <div class="part-three" style="background: #fff">
              <img
                  src="../assets/imgs/124/part-4-title.png"
                  class="part-two-title-img"
              />
              <div class="main-content" style="padding: 0">
                  <div class="part-four-items">
                    领军人才、拔尖人才、高级人才、优秀人才的引进， 由区委编办、区人社局、区教育局等相关部门组成教育人才引进工作小组，通过公开招聘方式引进；实施 “编制+ 员额” 和 “ 两自一包” 改革试点单位的人才引进，按程序报备后，可采取自主招聘方式引进。
                  </div>
              </div>
          </div>
            <div class="part-three" style="background: #fff">
                <img
                    src="../assets/imgs/124/part-5-title.png"
                    class="part-two-title-img"
                />
                <div class="main-content" style="padding: 0">
                    <div class="part-four-items">
                      引进培育津英教育人才享受有关激励政策的申报工作每年开展一次，由区教育局牵头组织申报和审核，报区人才工作领导小组办公室按程序审定后落实激励政策。
                    </div>
                </div>
            </div>
          <div class="contact">
              <img
                  class="top"
                  src="./../assets/imgs/124/part-6-title.png"
                  alt=""
              />
              <div class="content">
                  <div class="number">
                      <span class="label">政策咨询电话：</span>
                      <div>
                          <a href="tel:028-61888121">028-82511600</a>
                      </div>
                  </div>
                  <div class="unit">
                      <span class="label">责任单位：</span>
                      成都市新津区教育局
                  </div>
              </div>
          </div>

          <!-- <div class="bottom-info" style="margin-top: 0.25rem">
              责任单位：成都市人力资源和社会保障局专业技术人员服务管理处
          </div>
          <div class="bottom-info" style="margin-top:0.15rem">
              咨询电话： <a href="tel:028-61888245">028-61888245</a>、<a href="tel:028-61888121">028-61888121</a>
          </div> -->
          <!-- <bottom
                  phone="028-61888245"
                  phone2="028-61888121"
                  unit="成都市人力资源和社会保障局专业技术人员服务管理处"
              ></bottom> -->
        </div>
      </div>
  </div>
</template>

<script>
// import bottom from "../components/bottom.vue";
// import call from "../components/call.vue";

export default {
  name: "",
  data() {
      return {

      };
  },
  components: {
      // bottom,
      // call,
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.craft {
  background: #0839b7;
  overflow: hidden;
  padding: 0.24rem 0.12rem;
  padding-bottom: 1.65rem;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  overflow-y: auto;

  .part-title {
      font-size: 0.34rem;
      //font-family:: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
      color: #333333;
      position: relative;

      &::before {
          position: absolute;
          content: "";
          width: 0.28rem;
          height: 0.28rem;
          border-radius: 50%;
          background: none;
          border: 0.06rem solid #ff6d60;
          box-sizing: border-box;
          top: 0.08rem;
          left: -0.2rem;
      }
  }

  .part-text {
      font-size: 0.26rem;
      //font-family:: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #4e4e4e;
      line-height: 0.44rem;
      text-align: left;
  }

  .part-one {
      width: 7.5rem;
      min-height: 7.2rem;
      box-sizing: border-box;
      padding-bottom: 0.3rem;
      margin: 0 auto;

      .base-title {
          width: 7.26rem;
          min-height: 5.65rem;
          background: url(../assets/imgs/124/base-title.png);
          background-size: 100% 100%;
          position: relative;

          .part-one-content {
              width: 6.85rem;
              padding-bottom: 0.2rem;
              background: #ffffff;
              border-radius: 10px;
              position: absolute;
              top: 4.02rem;
              left: 0.22rem;
              padding-left: 0.36rem;
              padding-right: 0.37rem;
              box-sizing: border-box;
              padding-bottom: 0.35rem;

              .part-one-title-img {
                  position: absolute;
                  top: -0.32rem;
                  left: -0.18rem;
                  width: 7.03rem;
                  height: 1.37rem;
              }

              .part-one-title {
                  margin-top: 0.98rem;
                  text-align: left;
                  margin-left: 0.34rem;
              }

              .part-one-text {
                  margin-top: 0.16rem;
              }
          }
      }
  }

  .part-two-title-img {
      width: 7.03rem;
      height: 1.37rem;
      top: 0;
      left: -0.2rem;
      position: absolute;
  }

  .part-two {
      margin-left: 0.02rem;
      width: 6.85rem;
      margin-top: 0.22rem;
      background: #e8eeff;
      border-radius: 10px;
      box-sizing: border-box;
      display: inline-block;
      position: relative;

      .part-two-content {
          margin-top: 1.2rem;
          width: 100%;
          padding: 0.35rem;
          background: #ffffff;
          border-radius: 10px;
          box-sizing: border-box;
          font-size: 0.26rem;
          //font-family:: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #4e4e4e;
          line-height: 0.44rem;
          text-align: left;
      }
  }

  .part-three {
      width: 6.85rem;
      background: #e8eeff;
      border-radius: 0.28rem;
      margin-left: 0.02rem;
      margin-top: 0.22rem;
      box-sizing: border-box;
      margin: 0 auto;
      margin-top: 0.22rem;
      border: 0.00001px solid transparent;
      position: relative;
      padding: 1.44rem 0.25rem 0 0.25rem;
      padding-bottom: 0.35rem;

      .part-four-title {
          text-align: left;
          margin-left: 0.35rem;

          &::before {
              position: absolute;
              content: "";
              width: 0.28rem;
              height: 0.28rem;
              border-radius: 50%;
              background: none;
              border: 0.06rem solid #ff6d60;
              box-sizing: border-box;
              top: 0.08rem;
              left: -0.38rem;
          }
      }

      .main-content {
          margin-top: 0.1rem;
          width: 6.35rem;
          background: #ffffff;
          border-radius: 10px;
          box-sizing: border-box;
          padding-top: 0.5rem;
          padding-left: 0.35rem;
          padding-right: 0.31rem;
          padding-bottom: 0.2rem;

          .part-four-items {
              box-sizing: border-box;
              position: relative;
              margin-bottom: 0.15rem;
              font-size: 0.26rem;
              //font-family:: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #4e4e4e;
              line-height: 0.44rem;
              text-align: left;
          }
      }
  }

  .part-three-extra {
      width: 6.85rem;
      background: #e8eeff;
      border-radius: 0.15rem;
      margin-left: 0.02rem;
      margin-top: 0.22rem;
      box-sizing: border-box;
      margin: 0 auto;
      margin-top: 0.22rem;
      border: 0.00001px solid transparent;
      position: relative;
      padding: 1.44rem 0.25rem 0 0.25rem;
      padding-bottom: 0.35rem;
      .circle-title {
        font-weight: bold;
            width: 100%;
            // height: 0.67rem;
            font-size: 0.3rem;

            // border: 1px solid red;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            color: #333;
            margin-bottom: 0.5rem;
            margin-top: 0.2rem;

            .circle {
              width: 0.22rem;
              height: 0.22rem;
              border: 0.06rem solid #FF6D60;
              border-radius: 50%;
              margin-right: 0.05rem;
            }
      }

      .main-content {
          margin-top: 0.8rem;
          width: 6.35rem;
          background: #ffffff;
          border-radius: 10px;
          box-sizing: border-box;
          padding-top: 0.5rem;
          padding-left: 0.35rem;
          padding-right: 0.31rem;
          padding-bottom: 0.2rem;
          position: relative;
          // margin-bottom: 0.8rem;

          .part-four-title {
              text-align: left;
              position: absolute;
              top: 0;
              left: 50%;
              width:2.98rem;
              font-size: 0.32rem;
              background-color: #739bfeff;
              color: #fff;
              border-radius: 20px;
              text-align:center;
              padding: 0.18rem 0.2rem;
              transform: translate(-50%, -50%);
              white-space: nowrap;
          }

          .part-four-items {
              box-sizing: border-box;
              position: relative;
              margin-bottom: 0.15rem;
              font-size: 0.26rem;
              //font-family:: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #4e4e4e;
              line-height: 0.44rem;
              text-align: left;
              & > p {
                display: flex;
                align-items: center;
                font-size: 0.26rem;
                color: #4E4E4E;
                font-weight: bold;
                margin-top: 0.3rem;
                img {
                  width: 0.39rem;
                  height: 0.39rem;
                  margin-right: 0.14rem;
                }
              }
          }
      }
  }

  .part-four {
      width: 6.85rem;
      background: #e8eeff;
      border-radius: 10px;
      margin-left: 0.02rem;
      margin-top: 0.22rem;
      box-sizing: border-box;
      display: inline-block;
      position: relative;
      padding: 1.2rem 0.25rem 0 0.25rem;

      .part-four-title {
          text-align: left;
          margin-left: 0.35rem;

          &::before {
              position: absolute;
              content: "";
              width: 0.28rem;
              height: 0.28rem;
              border-radius: 50%;
              background: none;
              border: 0.06rem solid #ff6d60;
              box-sizing: border-box;
              top: 0.08rem;
              left: -0.38rem;
          }
      }

      .main-content {
          margin-top: 0.34rem;
          width: 6.35rem;
          background: #ffffff;
          border-radius: 10px;
          box-sizing: border-box;
          padding-top: 0.8rem;
          padding-left: 0.35rem;
          padding-right: 0.31rem;

          .part-four-items {
              box-sizing: border-box;
              border-left: 0.02rem dashed #739bfe;
              margin-bottom: 0.6rem;
              padding-left: 0.33rem;
              padding-top: 0.2rem;
              position: relative;
              font-size: 0.26rem;
              //font-family:: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #4e4e4e;
              line-height: 0.44rem;
              text-align: left;
              padding-bottom: 0.25rem;

              .title-bg {
                  position: absolute;
                  width: 3.31rem;
                  height: 0.6rem;
                  top: -0.6rem;
                  left: -0.25rem;
                  display: inline-flex;
                  align-items: center;
                  font-size: 0.34rem;
                  //font-family:: PingFang SC-Bold, PingFang SC;
                  font-weight: bold;
                  color: #3d5aa3;
                  padding-left: 0.58rem;
                  background: url(../assets/imgs/craft/part4-1.png);
                  background-size: 100% 100%;
                  white-space: nowrap;
              }

              .title-bg2 {
                  background: url(../assets/imgs/craft/part4-2.png);
                  background-size: 100% 100%;
              }

              .title-bg3 {
                  background: url(../assets/imgs/craft/part4-3.png);
                  background-size: 100% 100%;
              }

              .title-bg4 {
                  background: url(../assets/imgs/craft/part4-4.png);
                  background-size: 100% 100%;
              }

              .title-bg5 {
                  background: url(../assets/imgs/craft/part4-5.png);
                  background-size: 100% 100%;
              }

              .title-bg6 {
                  background: url(../assets/imgs/craft/part4-6.png);
                  background-size: 100% 100%;
              }

              .inside-title {
                  font-weight: 800;
              }

              .part-four-content1 {
                  margin-bottom: 0.2rem;

                  p {
                      margin: 0.01rem;
                  }
              }
          }
      }
  }

  .zccl {
      position: relative;
      margin-top: 0.22rem;
      font-size: 0.26rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #E8EEFF;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;

        font-weight: 500;
        text-align: left;
        color: #4e4e4e;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          margin-top: 0.2rem;
          position: relative;
          text-align: left;
          line-height: 0.44rem;

          color: #4E4E4E;
          font-size: 0.26rem;
          font-weight: normal;

          .title {
            font-weight: bold;
            position: absolute;
            top: -0.6rem;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
            // height: 0.67rem;
            font-size: 0.3rem;

            // border: 1px solid red;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .circle {
              width: 0.22rem;
              height: 0.22rem;
              border: 0.06rem solid #FF6D60;
              border-radius: 50%;
            }
          }

        }
      }
    }

}
</style>
